export default class HomeState {}
